import { mergeTranslations } from 'react-admin';
import { TranslationMessages } from 'ra-core';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';
import { raSupabaseEnglishMessages } from 'ra-supabase';
import enTranslations from './translations/en.json';
import ukTranslations from './translations/uk.json';

const raSupabaseEnglishMessagesOverride = {
	'ra-supabase': {
		auth: {
			password_reset: 'Check your emails for a Reset Password message.'
		}
	}
};

const translations: Record<string, TranslationMessages> = {
	en: mergeTranslations(
		englishMessages,
		raSupabaseEnglishMessages,
		raSupabaseEnglishMessagesOverride,
		enTranslations
	),
	uk: mergeTranslations(ukTranslations)
};

export const i18nProvider = polyglotI18nProvider(
	(locale: string) => translations[locale],
	'uk',
	[
		{ locale: 'uk', name: 'Укр' },
		{ locale: 'en', name: 'Eng' }
	],
	{ allowMissing: true }
);
